import { onMounted } from 'vue'
import { useStoreApp } from "@/store/app";
import router from "@/router";
import { get } from "lodash-es";

/**
 * 初始化
 */
export default function useInit() {

    const appStore = useStoreApp()

    onMounted(() => {
        if (get(router.currentRoute.value.query, 'mock')){
            return;
        }
        appStore.Init().then(() => {
            appStore.FetchInfo()
        }).catch(() => {
            router.push({
                name: 'user.login'
            })
        })
    })
}
